import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import { green50 } from 'material-ui/styles/colors';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn } from 'material-ui/Table';

import { currency } from '../services/services';

const style = {
  jumbotron: {
    marginTop: '20px',
    marginLeft: '5px',
    marginRight: 'auto',
  },
  totalSumTableRow: (sum) => {
    if (sum > 0) {
      return { 'background-color': green50, wordWrap: 'break-word', 'border-top': '2px' };
    } else {
      return { wordWrap: 'break-word', 'border-top': '2px' };
    }
  },
};

class CalculationResult extends Component {
  componentDidMount() {
    // Get the components DOM node
    var elem = findDOMNode(this);
    //  alert(elem);
    // Set the opacity of the element to 0
    elem.style.opacity = 0;
    window.requestAnimationFrame(function() {
    // Now set a transition on the opacity
      elem.style.transition = 'opacity 2250ms';
      // and set the opacity to 1
      elem.style.opacity = 1;
    });
  }

  render() {
    return (
      <Paper style={style.jumbotron}>
        <h2 style={{paddingLeft :'10px', paddingTop : '10px' , fontSize: '22px'}}>Berechnungsergebnis</h2>
        <Table >
          <TableBody displayRowCheckbox ={false}>
              {this.showExtraJudicial()}
              {this.showJudicial()}
              <TableRow >
                <TableRowColumn style={{ paddingLeft: '5px', paddingRight: '1px'}}><strong>netto</strong></TableRowColumn>
                <TableRowColumn />
                <TableRowColumn style={{   paddingLeft: '1px', paddingRight: '1px'}}>
                  <strong>
                    { currency(this.calculateSum() )}
                  </strong>
                </TableRowColumn>
            </TableRow>
            { this.showValueAddedTax() }
            <TableRow style={style.totalSumTableRow(this.calculateSum() * ((this.props.feeCalculation.valueAddedTax  / 100) ))}>
              <TableRowColumn style={{ paddingLeft: '5px', paddingRight: '1px'}}><strong>Kosten</strong></TableRowColumn>
              <TableRowColumn />
              <TableRowColumn style={{   paddingLeft: '1px', paddingRight: '1px'}}>
                <strong>
                {currency(this.calculateSum() * (1 +(this.props.feeCalculation.valueAddedTax  / 100)))}
                </strong>
              </TableRowColumn>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
  ); }

  showValueAddedTax() {
      let valueAddedTaxSum = this.calculateSum() * this.props.feeCalculation.valueAddedTax  / 100;
      console.log(valueAddedTaxSum);
      if (valueAddedTaxSum <= 0){
        return "";
        }
      return (
        <TableRow>
          <TableRowColumn style={{ paddingLeft: '5px', paddingRight: '1px'}}>zzgl. U-St.</TableRowColumn>
          <TableRowColumn style={{ width: '55px' , paddingLeft: '1px', paddingRight: '1px'}}>{ this.props.feeCalculation.valueAddedTax} %</TableRowColumn>
          <TableRowColumn style={{   paddingLeft: '1px', paddingRight: '1px'}}>{currency(this.calculateSum() * this.props.feeCalculation.valueAddedTax / 100) }</TableRowColumn>
        </TableRow>
      );
    }

    showExtraJudicial() {
        if (!this.props.feeCalculation.extraJudicialIsActive) {
            return "";
            }
        return (
            this.props.feeCalculation.feeMattersExtraJudicial.filter(matter => (matter.sum > 0) || (matter.sum < 0)).map(matter =>
            <TableRow>
              <TableRowColumn style={{wordWrap: 'break-word', whiteSpace: 'normal' , paddingLeft: '5px', paddingRight: '1px'}} > { matter.ziff } { matter.kurzbezeichnung }</TableRowColumn>
              <TableRowColumn style={{ width: '43px' , paddingLeft: '1px', paddingRight: '1px'}} >{matter.isSetted}</TableRowColumn>
              <TableRowColumn style={{   paddingLeft: '1px', paddingRight: '1px'}}>{currency(matter.sum )}</TableRowColumn>
            </TableRow>)
        );
    }
    showJudicial() {
        if (!this.props.feeCalculation.judicialIsActive) {
            return '';
            }
        return (
            this.props.feeCalculation.feeMattersJudicial.filter(matter => (matter.sum > 0) || (matter.sum < 0)).map(matter =>
                <TableRow>
                <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal' ,paddingLeft: '5px', paddingRight: '1px'}} > { matter.ziff } { matter.kurzbezeichnung }</TableRowColumn>
                    <TableRowColumn style={{  width: '43px' , paddingLeft: '1px', paddingRight: '1px'}} > { matter.isSetted }</TableRowColumn>
                    <TableRowColumn style={{paddingLeft: '1px', paddingRight: '1px'}}>{currency(matter.sum)}</TableRowColumn>
                </TableRow>
            )
        );
  }
  calculateSum() {
    const sumFunc  = function(acc, elem ) {
      if(isFinite(elem.sum) && elem.sum !== '') { return acc + parseFloat(elem.sum);
      } return acc;
    };
    let sum = this.props.feeCalculation.feeMattersExtraJudicial.reduce(sumFunc, 0) * this.props.feeCalculation.extraJudicialIsActive;
    sum = (this.props.feeCalculation.judicialIsActive) ? this.props.feeCalculation.feeMattersJudicial.reduce(sumFunc, sum) : sum;
    return sum;
    }
}

function Currency(amount) {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
}

function mapStateToProps(state) {
  return {
    feeTable: state.feeTable,
    feeMatters: state.feeMatters,
    feeCalculation: state.feeCalculation,
  };
}

export default connect(mapStateToProps)(CalculationResult);



// WEBPACK FOOTER //
// ./src/containers/calculationResult.jsx